import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import {DateUtils} from '../../utils/date.utils';

@Pipe({
  name: 'treeFilter',
})
export class TreeFilterPipe implements PipeTransform {
  datePipe = new DatePipe('en-US');

  transform(items: any[], searchParam: string, searchValue: any, match?): any {
    if (!items) {
      return [];
    } else if (!searchParam.length) {
      return items;
    } else {
      const getMatchedList = (filteredItem, searchKeys, flag?) => {
        let found = false;
        searchKeys.forEach(searchKey => {
          if(flag) {
            const isMatched = searchKey && DateUtils.getLocalTime(filteredItem).toLowerCase().includes(searchKey.toLowerCase()) ||
              String(searchKey) && String(filteredItem).toLowerCase().includes(String(searchKey).trim().toLowerCase());
            found = isMatched ? isMatched : found;
          } else {
            found = String(searchKey) && String(filteredItem).toLowerCase().includes(String(searchKey).trim().toLowerCase()) ? String(filteredItem).toLowerCase().includes(String(searchKey).trim().toLowerCase()) : found;
          }
          });
        return found;
      }
      const looper = (filterParams, accumulator) => {
        return filterParams.reduce((res, val) => {
          return res.filter((item: any) => {
            const searchValueList = searchValue[val].split(',');
            if (!(isNaN(item[val]) && !isNaN(Date.parse(item[val])))) {
              if (match) {
                if (match[val]) {
                  return getMatchedList(item[val],searchValueList); //String(item[val]).toLowerCase().includes(String(searchValue[val]).toLowerCase());
                } else {
                  return !getMatchedList(item[val],searchValueList); //(String(item[val]).toLowerCase().includes(String(searchValue[val]).toLowerCase()));
                }
              }
              return getMatchedList(item[val],searchValueList); //String(item[val]).toLowerCase().includes(String(searchValue[val]).toLowerCase());
            } else {
              return getMatchedList(item[val],searchValueList,true);
              //DateUtils.getLocalTime(item[val]).toLowerCase().includes(searchValue[val].toLowerCase())  || String(item[val]).toLowerCase().includes(String(searchValue[val]).toLowerCase());
              // todo Check  filter  for other files
             // return this.datePipe.transform(item[val], 'shortDate').includes(searchValue[val]);
            }
          });
        }, accumulator);
      };
      return looper(searchParam, items);
    }
  }
}
